

import React, { lazy } from 'react';

const HomePage = lazy(() => import('../pages/Home/HomePage'));
const TermsAndConditions = lazy(() => import('../pages/TermsAndConditions'));
const Casino = lazy(() => import('../pages/Casino'));
const Sportsbook = lazy(() => import('../pages/Sportsbook'));
const FaqViewAll = lazy(() => import('../pages/FaqViewAll'));

export const publicRoutes = [
  { index: true, element: <HomePage /> },
  { path: 'guidelines/:section', element: <TermsAndConditions /> },
  { path: 'Casino', element: <Casino /> },
  {
    path: "/sportsbook" , element: <Sportsbook />
  },
  {path:'faqviewall/:faq',element:<FaqViewAll/>}
];

export const authRoutes = [
  // Index route for dashboard home
  
  
];